var _style, _rect, _g, _path, _circle, _circle2, _circle3, _g2, _path2, _path3, _circle4, _circle5, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgISuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;fill-opacity:0;}\r\n\t.st1{fill:#96EABE;}\r\n\t.st2{opacity:0.6;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{opacity:0.3;fill:url(#SVGID_4_);enable-background:new    ;}\r\n\t.st6{fill:#37C473;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#00510B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 200,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.6,
    cy: 99.4,
    r: 75
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.55,
    y1: 301.6,
    x2: 99.55,
    y2: 224.4,
    gradientTransform: "matrix(1 0 0 1 0 -200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005176686,
    style: {
      stopColor: "#F6F9FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    style: {
      stopColor: "#F6F9FE",
      stopOpacity: 0.1413
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6F9FE",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.1,34.5c-11-6.4-23.9-10.1-37.5-10.1S73.1,28.1,62,34.5v67.1h75.1V34.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8,
    y1: 299.4,
    x2: 148.3,
    y2: 299.4,
    gradientTransform: "matrix(1 0 0 1 0 -200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5ACC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009950"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 99.6,
    cy: 99.4,
    r: 48.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.1,
    y1: 299.4,
    x2: 137.1,
    y2: 299.4,
    gradientTransform: "matrix(1 0 0 1 0 -200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001118171,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 99.6,
    cy: 99.4,
    r: 37.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.0947,
    y1: 200.3839,
    x2: 178.0954,
    y2: 200.3839,
    gradientTransform: "matrix(0.7071 0.7071 -0.7071 0.7071 141.8767 -141.7062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001118171,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1239,
    style: {
      stopColor: "#FBFEFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2597,
    style: {
      stopColor: "#EDFAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    style: {
      stopColor: "#D7F3E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5463,
    style: {
      stopColor: "#B9EAD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6947,
    style: {
      stopColor: "#91DDBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#61CF9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#29BE78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#27BD77"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 99.6,
    cy: 99.4,
    r: 37.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,128.9c-7.9,0-15.3-3.1-20.9-8.6c-5.6-5.6-8.6-13-8.6-20.9s3.1-15.3,8.6-20.9 c11.5-11.5,30.2-11.5,41.7,0s11.5,30.2,0,41.7C114.9,125.8,107.5,128.9,99.6,128.9z M99.6,70.9c-7.3,0-14.6,2.8-20.2,8.3 c-5.4,5.4-8.3,12.5-8.3,20.2c0,7.6,3,14.8,8.3,20.2c5.4,5.4,12.5,8.3,20.2,8.3c7.6,0,14.8-3,20.2-8.3c11.1-11.1,11.1-29.2,0-40.3 C114.2,73.7,106.9,70.9,99.6,70.9z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.3,59.8h-1.6v-1.6c0-0.7-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2v1.6h-1.6c-0.7,0-1.2,0.5-1.2,1.2 s0.5,1.2,1.2,1.2h1.6v1.6c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-1.6h1.6c0.7,0,1.2-0.5,1.2-1.2S50.9,59.8,50.3,59.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M145.5,148.3h-2.2v-2.2c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6v2.2h-2.2c-0.9,0-1.6,0.7-1.6,1.6 c0,0.9,0.7,1.6,1.6,1.6h2.2v2.2c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-2.2h2.2c0.9,0,1.6-0.7,1.6-1.6 C147.1,149.1,146.4,148.3,145.5,148.3z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 118.8,
    cy: 45,
    r: 2.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 77.9,
    cy: 34,
    r: 1.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.5,112.8c-0.7,0-1.5-0.3-2-0.8l-9.8-9.1l4.1-4.4l7,6.5l9.9-18.5l5.3,2.8l-11.8,21.9 c-0.4,0.8-1.2,1.4-2.1,1.5C98.8,112.8,98.7,112.8,98.5,112.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgISuccess);
export default __webpack_public_path__ + "static/media/i-success.98bd0dbf6b688988095bedd358085714.svg";
export { ForwardRef as ReactComponent };